import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {DisciplineSubscale} from '../models/models.lib';
import {ApiService} from '../api/api.service';

const { apiUrl } = environment;

export abstract class CasiDisciplineSubscaleService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(disciplineId: number): void {
    this.fetch(disciplineId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(id: number): Observable<DisciplineSubscale[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/discipline/subscale/all/${id}`))
      .pipe(
        map((response: any, i) => {
          return <DisciplineSubscale[]>response;
        }),
        map(r => r.map(x => DisciplineSubscale.create(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class DisciplineSubscaleService extends CasiDisciplineSubscaleService{

  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(id: number) {
    return this.apiService.getHttpCall(`discipline/subscale/all/${id}`, 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('discipline/subscale', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`discipline/subscale/${id}`, dataItem , 'update');
  }

  moveDown(id: number): Promise<any>  {
    return this.apiService.getHttpCallAsPromise(`discipline/subscale/move/down/${id}`, 'moveDown');
  }

  moveUp(id: number): Promise<any>  {
    return this.apiService.getHttpCallAsPromise(`discipline/subscale/move/up/${id}`, 'moveUp');
  }
}
